module.exports = __webpack_public_path__ + "static/media/transf4.44d66d6d.jpg";